var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D21E4BB0-0CA0-4AE9-84F9-C176977B99DC@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---My-Information",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contact",
    transform: "translate(-746.000000, -1883.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(269.000000, 1700.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Input-/-Primary-/-Default-Copy-3",
    transform: "translate(465.000000, 149.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(12.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3845247e-15,8.21706548 C0.0894693351,7.57633837 0.157636464,6.93195563 0.271357608,6.29588105 C0.915995726,2.69312034 3.43129724,0.241873858 7.02776876,0.116254164 C11.35802,-0.0346224921 15.7013804,-0.0425983483 20.0309762,0.115589467 C23.9453425,0.258490267 26.7801773,3.19759329 26.9024194,7.16824039 C27.0325269,11.3844773 27.0325269,15.6110165 26.9024194,19.8272535 C26.7801773,23.7979006 23.9463257,26.7366714 20.0313039,26.8799044 C15.7017082,27.0384245 11.3573646,27.0424125 7.02809647,26.8775782 C3.11307471,26.7283631 0.406708664,23.7826135 0.144855106,19.8059846 C0.122241993,19.4620258 0.0494867344,19.1210579 0,18.7787608 C0,15.2580848 0,11.737409 2.3845247e-15,8.21706548 Z M13.503646,24.5266945 C15.4850808,24.5266945 17.4684821,24.5868457 19.4472952,24.5127367 C22.5498828,24.3960899 24.4582346,22.5184403 24.5306621,19.3752884 C24.6204592,15.4588106 24.6204592,11.5370156 24.5306621,7.62020557 C24.4582346,4.47771822 22.5485718,2.55620148 19.4472952,2.4894037 C15.5109712,2.4049926 11.5703869,2.40565721 7.63406289,2.4894037 C4.55638265,2.55487217 2.64245943,4.43750654 2.55888913,7.54543186 C2.45270572,11.5114264 2.45270572,15.4843998 2.55888913,19.4503943 C2.64245943,22.5579873 4.55638265,24.3970869 7.63439068,24.5127367 C9.5882965,24.5865134 11.5471182,24.5266945 13.503646,24.5266945 L13.503646,24.5266945 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,7 C10.1342288,7 7,10.1339701 7,13.9998333 C7,17.86603 10.1342288,21 14,21 C17.8661046,21 21,17.86603 21,13.9998333 C21,10.1339701 17.8661046,7 14,7 Z M14,18.5899208 C11.4649423,18.5899208 9.41002184,16.5349513 9.41002184,13.9998333 C9.41002184,11.4647152 11.4649423,9.40974582 14,9.40974582 C16.5350577,9.40974582 18.5899782,11.4647152 18.5899782,13.9998333 C18.5899782,16.5349513 16.5350577,18.5899208 14,18.5899208 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,6.50015012 C23,7.3284613 22.3284612,8 21.5001502,8 C20.6718391,8 20,7.3284613 20,6.50015012 C20,5.67153862 20.6718391,5 21.5001502,5 C22.3284612,5 23,5.67153862 23,6.50015012 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.86c1e0e3110f613af8b59427b4a4821e.svg";
export { ForwardRef as ReactComponent };